import { render, staticRenderFns } from "./SentimentCatIndia.vue?vue&type=template&id=0b77bbfa&scoped=true"
import script from "./SentimentCatIndia.vue?vue&type=script&lang=js"
export * from "./SentimentCatIndia.vue?vue&type=script&lang=js"
import style0 from "./SentimentCatIndia.vue?vue&type=style&index=0&id=0b77bbfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b77bbfa",
  null
  
)

export default component.exports